import { render, staticRenderFns } from "./MarkdownRender.vue?vue&type=template&id=ed318bdc&scoped=true&"
import script from "./MarkdownRender.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MarkdownRender.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MarkdownRender.vue?vue&type=style&index=0&id=ed318bdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed318bdc",
  null
  
)

export default component.exports